module.exports = __webpack_public_path__ + "static/media/settings.19b4a421.svg";